import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createOpportunity,
  deleteOpportunity,
  getAllOpportunities,
  getOpportunityById,
  updateOpportunity,
} from "./services/opportunity.services";
import { IOpportunity, IOpportunityInitialState } from "./opportunityModel";

const initialState: IOpportunityInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  OpportunityID: null,
  OpportunityList: [],
  OpportunityDetail: {
    AddCustomerID: null,
    OpportunityTypeID: null,
    ExpectedValue: null,
    SetPriority: "",
    FollowupDate: "",
    AssignTeamID: null,
    IsActive: 1,
  },
};

export const opportunitySlice = createSlice({
  name: "opportunity",
  initialState,
  reducers: {
    clearOpportunityDetails: (state) => {
      state.OpportunityDetail = initialState.OpportunityDetail;
    },
    setOpportunityID: (state, action) => {
      state.OpportunityID = action.payload;
    },
    clearOpportunityID: (state) => {
      state.OpportunityID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllOpportunities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllOpportunities.fulfilled,
      (state, action: PayloadAction<IOpportunity[]>) => {
        state.loading = false;
        state.OpportunityList = action.payload;
      }
    );
    builder.addCase(getAllOpportunities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OpportunityList = [];
    });

    builder.addCase(createOpportunity.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createOpportunity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createOpportunity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateOpportunity.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateOpportunity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateOpportunity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteOpportunity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteOpportunity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteOpportunity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getOpportunityById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getOpportunityById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.OpportunityDetail = action.payload;
    });
    builder.addCase(getOpportunityById.rejected, (state, action) => {
      state.formLoading = false;
      state.OpportunityDetail = initialState.OpportunityDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearOpportunityDetails, setOpportunityID, clearOpportunityID } =
  opportunitySlice.actions;
export default opportunitySlice.reducer;
